import { LoginBaseModel } from './login-base-model';
import { AuthResponseModel } from './auth-response.model';
import { AuthRequestModel } from './auth-request';

// PATH
// /ws/user/sign/up

// SUCCESS
// 200
// null

// ERROR
// 400
// {"error": {"message": "This email address is already in use. <br/>Current users, please sign in.", "code": 400, "arguments": null}}

export interface SignUpRequestModel extends AuthRequestModel {
  email: string;
  password: string;
  first_name: string;
  last_name: string;
}

export type SignUpResponseModel = AuthResponseModel;

export class SignUpModel extends LoginBaseModel {
  // service version
  version = 3;

  email: string;
  password: string;
  name: string;
  firstName: string;
  lastName: string;

  static toJSON(value: SignUpModel): SignUpRequestModel {
    return {
      version: value.version,

      email: value.email,
      password: value.password,
      first_name: value.firstName,
      last_name: value.lastName,

      // Required
      group_invite_mode: value.groupInviteMode,
      group_invite_key: value.groupInviteKey,
      group_code_mode: value.groupCodeMode,
      group_code: value.groupCode,
      group_ovid_mode: value.groupOvidMode,
      group_ovid_osptok: value.groupOvidOsptok,

      // optoinal platform params
      platform: value.platform,
      return_to: value.returnTo,
      brand_id: value.brandId,
      locale_id: value.localeId,
      timestamp: value.timestamp,

      // verification
      site_verify_response: value.site_verify_response,
    };
  }
}
